// extracted by mini-css-extract-plugin
module.exports = {"wrapDropdownSettings":"DropdownProfile_wrapDropdownSettings__3S_MZ","listPages":"DropdownProfile_listPages__21hb_"};